import React, { useState } from "react";
import { Modal, Button, Input, Flex, theme } from "antd";
import ri from "../../constants/remixicons";
import { brandColors } from "../../constants/brandColors";

export const getIconColor = (iconName) => {
  if (!iconName) return undefined;
  return brandColors[iconName];
};

export default function IconPicker({ value, onChange }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [search, setSearch] = useState(undefined);
  const { token } = theme.useToken();

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedIcon(value);
    setSearch(undefined);
  };

  const handleSelect = () => {
    onChange(selectedIcon);
    setIsModalOpen(false);
    setSearch(undefined);
  };

  return (
    <>
      <Button
        icon={<Icon value={value ?? "user-line"} />}
        onClick={() => setIsModalOpen(true)}
      />
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        onClose={handleCancel}
        title="Choose an icon"
        width={798}
        styles={{
          body: {
            height: "60vh",
            overflowY: "auto",
            paddingRight: 15,
          },
        }}
        onOk={handleSelect}
      >
        <Input
          placeholder="Search"
          style={{ marginBlock: 15 }}
          value={search ?? ""}
          onChange={(e) => setSearch(e.target.value)}
        />
        {Object.keys(ri.categories).map((cat, ind) => {
          const query = (search || "").trim().toLowerCase();
          let iconPrefixes = !query
            ? Object.keys(ri.tags[cat])
            : Object.keys(ri.tags[cat]).filter((icon) => {
                if (icon.toLowerCase().includes(query)) return true;
                return ri.tags[cat][icon]
                  .toLowerCase()
                  .split(",")
                  .some((tag) => tag.includes(query));
              });
          let iconsToDisplay = !query
            ? ri.categories[cat]
            : ri.categories[cat].filter((icon) => {
                return (
                  [...iconPrefixes].filter((prefix) => icon.includes(prefix))
                    .length > 0
                );
              });
          return iconsToDisplay.length === 0 ? (
            <React.Fragment key={ind}></React.Fragment>
          ) : (
            <div
              style={{
                marginBottom: 16,
              }}
              key={ind}
            >
              <div
                style={{
                  fontSize: 16,
                  color: token.colorTextTertiary,
                  marginBottom: 5,
                }}
              >
                {cat}
              </div>
              <Flex gap={8} wrap>
                {iconsToDisplay.map((icon) => {
                  return (
                    <span
                      key={icon}
                      style={
                        selectedIcon === icon
                          ? {
                              border: "1px solid",
                              borderColor: token.colorPrimary,
                              background: token.colorPrimaryBg,
                              width: 30,
                              height: 30,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }
                          : {
                              border: "1px solid #ccc",
                              width: 30,
                              height: 30,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }
                      }
                      onClick={() => setSelectedIcon(icon)}
                    >
                      <span className={"ri-" + icon} style={{ fontSize: 22 }} />
                    </span>
                  );
                })}
              </Flex>
            </div>
          );
        })}
      </Modal>
    </>
  );
}

function Icon({ value, color, size }) {
  return <span className={"ri-" + value} style={color ? { color } : {}} />;
}

export { Icon };
